import React from 'react';
import { GenericListPage } from '../../components/generic';
import { useReminders, Reminder } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<Reminder>
      useData={useReminders}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;

